<template>
    <div data-name="request" class="sugg-spots" :class="{'long-line':!isPartnerUpdate}">
        <div v-if="!isPartnerUpdate" class="d-flex justify-content-between w-100">
            <div class="d-flex align-items-center">
                <Spot :value="spotPosition[0].position + 1"/>
                <p data-name="request-date">{{spotPosition[0].date | secondsToDateMonth}}</p>
            </div>
            <div data-name="request-line">
                <div data-name="req-arrow">
                    <Icon :icon="arrow"/>
                </div>
            </div>
            <div data-name="second-date" class="d-flex align-items-center justify-content-between">
                <p data-name="request-date">{{spotPosition[1].date | secondsToDateMonth}}</p>
                <Spot :value="spotPosition[1].position + 1"/>
            </div>
        </div>
        <div v-else class="d-flex justify-content-between w-100">
            <Spot :value="spotPosition[0].position + 1"/>
            <div data-name="req-arrow">
                <Icon :icon="arrow" width="25"/>
            </div>
            <Spot :value="spotPosition[1].position + 1"/>
        </div>
        
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Spot from './Spot'
import Icon from '@/components/Theme/Icon'
import {dates} from '../../../../../core/filters'
export default {
    name: 'SuggestedSpots',
    components: {
        Spot,
        Icon
    },
    props: {
        data: Object,
        isPartnerUpdate: Boolean
    },
    filters: {
        secondsToDateMonth: dates.secondsToDateMonth
    },
    computed: {
        ...mapState([
            'user'
        ]),
        spotPosition() {
            
            const campaignData = {...this.data}

            let spotsData = [
                {
                    position: campaignData.sender.spot_position,
                    date: campaignData.sender.update_date._seconds
                },
                {
                    position: campaignData.receiver.spot_position,
                    date: campaignData.receiver.update_date._seconds
                }
            ];

            if(this.isPartnerUpdate) {
                spotsData = spotsData.map(item => ({position: item.position}))
                return campaignData.sender.uid !== this.user.uid ? spotsData : spotsData.reverse()
            }
            
            return campaignData.sender.uid === this.user.uid ? spotsData : spotsData.reverse()
                
        },
        arrow() {
            const sender = {...this.data.sender}
            return sender.uid === this.user.uid ? 'sent-req-arrow':  'receive-req-arrow'
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../../assets/scss/variables.scss';

div.sugg-spots {
    height: 28px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: max-content;

    &.long-line {
        width: 100%;
        max-width: 278px;
    }

    div[data-name="second-date"] {
        p {
            margin-right: 8px;
        }
    }
    p[data-name="request-date"] {
        color: $c6;
        font-size: $p5;
        z-index: 2;
        &:last-child {
            margin-left: 8px;
        }
    }

    div[data-name="request-line"] {
        width: 90%;
        height: 100%;
        display: flex;
        justify-content: center;
        position: absolute;
        background: #F4F4F4;
        transform: matrix(-1, 0, 0, 1, 0, 0);
        margin: auto;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1;
    }
}
</style>